export default __webpack_public_path__ + "static/media/onlyAudio-Q.8dc27fdf.png";